"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var GwsGameProviderZonesList = /** @class */ (function (_super) {
    __extends(GwsGameProviderZonesList, _super);
    function GwsGameProviderZonesList(props) {
        return _super.call(this, props) || this;
    }
    GwsGameProviderZonesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                loading: false
            });
        });
        this.setState({
            data: [],
            loading: true,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.recordKey.key);
        });
        this.props.state.setExtBreadCrumbPath(["Список зон провайдера"]);
    };
    GwsGameProviderZonesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    GwsGameProviderZonesList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            if (nextProps.recordKey != this.props.recordKey) {
                nextProps.data.LoadData(nextProps.recordKey.key);
            }
        }
    };
    GwsGameProviderZonesList.prototype.getColumns = function () {
        var _this = this;
        return [
            {
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 250,
            }, {
                title: 'Operator id',
                dataIndex: this.props.data.dk_operator_id,
                key: this.props.data.dk_operator_id,
                width: 250,
            }, {
                title: 'Для стримеров',
                dataIndex: this.props.data.dk_is_default_streamer_zone,
                key: this.props.data.dk_is_default_streamer_zone,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.is_default_streamer_zone, "Да", "Нет")));
                },
                width: 100,
                align: "center"
            }, {
                title: 'Описание',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                align: "center",
                width: 250,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 80
            }
        ];
    };
    GwsGameProviderZonesList.prototype.onEditClick = function (record) {
        if (this.props.onEdit) {
            this.props.onEdit(record);
        }
    };
    GwsGameProviderZonesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0417\u043E\u043D\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    GwsGameProviderZonesList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.setState({ loading: true }, function () {
                _this.props.data.LoadData(_this.props.recordKey.key, function () {
                    _this.setState({ loading: false });
                });
            });
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
        if (action == "create") {
            if (this.props.onNew) {
                this.props.onNew();
            }
        }
    };
    GwsGameProviderZonesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Вернуться", refresh: "Обновить", create: "Создать" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { size: "small", bordered: true, columns: this.getColumns(), dataSource: this.state.data, loading: this.state.loading, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    defaultPageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return (React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]"))); }, scroll: { x: true } })));
    };
    return GwsGameProviderZonesList;
}(React.Component));
exports.default = GwsGameProviderZonesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ui/component/GwsGameProviderZonesList.tsx
// module id = 1884
// module chunks = 0